import { Categories } from './keys';
import {
    Category_1_Products,
    Category_2_Products,
    Category_3_Products,
    Category_4_Products,
    Category_5_Products,
    Category_6_Products,
    Category_7_Products,
    Category_8_Products,
    Category_9_Products,
    Category_10_Products,
    Category_11_Products,
    Category_12_Products,
    Category_13_Products,
    Category_14_Products,
    Category_15_Products,
    Category_16_Products
} from './keys';

export const ProductsData = [
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_1.key}`,
        "title": `${Category_1_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_1.key}.jpg`,
        "description": [
            "Endoscopy camera is the latest version of the high definition endoscopy camera, which delivers the clearest, sharpest picture. With the native progressive scan it provides the sharpest details with incomparable natural color retention at the high spatial and temporal resolution. Even the finest variations in tissue structures are distinguishable.",
            "It will definitely enhance the capabilities of surgeons performing minimally invasive procedures."
        ],
        "specification": [
            "1/3 C-MOS image sensor for full high definition use",
            "Full HD resolution 1920 x 1080 pixels (16:9)",
            "Full HD resolution video recording and image capturing",
            "High sensitivity requires less light from illumination",
            "New image enhancement functions on clarity and color",
            "High interference immunity from electro-surgery",
            "Digital filters for using with fiber flexible scope",
            "Full digital chain achieved on DVI-D or HDMI output",
            "Up to 2.5x digital zoom function and freeze function",
            "Silicon cable for extra flexibility and sterilization stability",
            "Metal camera head housing for high durability"
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_2.key}`,
        "title": `${Category_1_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_2.key}.jpg`,
        "description": [
            "DIGITAL CO2 INSUFFLATOR (LED Display / Touch Screen) 30L / 40L & 50L"
        ],
        "specification": [
            "Micro Processor Based Continuous insufflation for Quick and Precise insufflation. Faster than Conventional Pulse mode.",
            "Fully automatic delivery to maintain selected pressure. The insufflator selects optimum required flow without human intervention.",
            "Dedicated soft mode-controls insufflation with additional safety to minimize risk of faulty incision. Also useful for paediatric surgery.",
            "Digital display for set pressure, actual pressure, Set flow, actual flow & volume.",
            "Built in Self Test, Occlusion Test, Continuous Monitoring of Safety Parameters."
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_3.key}`,
        "title": `${Category_1_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [
            "Automatic over temperature protection",
            "Low Heat Generation",
            "Digital display/adjustment of the light intensity",
            "User friendly: Different user memories (desire settings can be saved)",
            "Telescope selection: can be selected as per the dia of telescope being used"
        ],
        "technicalSpecifications": [
            "LED technology with 300 lumens / watt performances",
            "Nominal Power: 100 W (light intensity equivalent to 300W Xenon light source)",
            "LED Lifetime: Approx 50,000 hours (in advised conditions of use)",
            "Color Temperature: > to 5500 K",
            "Light intensity: up to 260,000 lux (output of a 4.8mm cable)",
            "Light cable input: Forceto/Storz Type Only"
        ]
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_4.key}`,
        "title": `${Category_1_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_4.key}.jpg`,
        "description": [
            "High quality fibers and bonding material to withstand higher temperature, different diameters and lengths are available, resistant to chemicals and solutions."
        ],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_5.key}`,
        "title": `${Category_1_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [
            "Hysteroscopy Intra Cavity Pressure Management",
            "TURP Intra Cavity Pressure Management",
            "Laparoscopy Irrigation / Suction",
            "Self Test Automatically at Power On",
            "Best In Class Piezo Pressure Sensor",
            "Fluid Flow Rate Management",
            "Fast And Accurate Pressure Control",
            "Large Numerical And Symbolic Display of Intra-cavity Pressure",
            "Non-disposable Sterilizable Tubings"
        ],
        "technicalSpecifications": [
            "Pump Adjustable Values",
            "Flow : 0.01 To 1.5 Ltr/min",
            "Pressure : 50 to 450mmHg",
            "Display : LCD Display"
        ]
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_6.key}`,
        "title": `${Category_1_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_6.key}.jpg`,
        "description": [
            "Automatic Tourniquet Single Channel and Double Chennel"
        ],
        "specification": [
            "Portability: Mobile, Light weight & Easy to carry tourniquet system",
            "System Controls: Controlled with Microprocessor to match up with the innovative technology",
            "Rapid cuff inflation",
            "High definition LCD display",
            "Extended pressure interlock",
            "Advanced safety features: Visual & Audio safety alarm for extended time then the stipulated set timings, pressure & low battery",
            "Long battery life",
            "Feather touch panel",
            "Highly calibrated & tested",
            "Online pressure/time setting: It is possible to change the setting of pressure, time, inflate, deflate in working mode.",
            "Accessories: Medical grade autoclavable silicon tubing & set of autoclavable cuff's."
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_7.key}`,
        "title": `${Category_1_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_8.key}`,
        "title": `${Category_1_Products.product_8.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_8.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_9.key}`,
        "title": `${Category_1_Products.product_9.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_9.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_10.key}`,
        "title": `${Category_1_Products.product_10.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_10.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_11.key}`,
        "title": `${Category_1_Products.product_11.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_11.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_1.key}`,
        "parentTitle": `${Categories.category_1.title}`,
        "key": `${Category_1_Products.product_12.key}`,
        "title": `${Category_1_Products.product_12.title}`,
        "imageURL": `/assets/images/${Category_1_Products.product_12.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_2.key}`,
        "parentTitle": `${Categories.category_2.title}`,
        "key": `${Category_2_Products.product_2.key}`,
        "title": `${Category_2_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_2_Products.product_2.key}.jpg`,
        "description": [
            "Autoclavable / Rod Lens System / Fiber Optical Light Transmission"
        ],
        "specification": [
            "Diameter: 5mm to 10mm",
            "Lenght: Standard / Bariatric",
            "Angle of View: 00 / 300 / 450"
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_2.key}`,
        "parentTitle": `${Categories.category_2.title}`,
        "key": `${Category_2_Products.product_3.key}`,
        "title": `${Category_2_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_2_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [
            "Diameter: 3mm to 20mm",
            "Lenght: Paediatric / Standard / Bariatric",
            "Valve Type: Multifunctional / Magnetic / Automatic",
            "Obturator:Sharp / Blunt / Safety"
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_2.key}`,
        "parentTitle": `${Categories.category_2.title}`,
        "key": `${Category_2_Products.product_4.key}`,
        "title": `${Category_2_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_2_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [
            "Lap Gynae Instruments and Accessories",
            "Hystroscopy and TCRE",
            "Obst. and Gynae Surgery Instruments"
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_2.key}`,
        "parentTitle": `${Categories.category_2.title}`,
        "key": `${Category_2_Products.product_5.key}`,
        "title": `${Category_2_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_2_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_2.key}`,
        "parentTitle": `${Categories.category_2.title}`,
        "key": `${Category_2_Products.product_6.key}`,
        "title": `${Category_2_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_2_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [
            "Diameter: 3mm to 10mm",
            "Lenght: Paediatric / Standard / Bariatric",
            "Valve Type: Two Way / Trumpet"
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_2.key}`,
        "parentTitle": `${Categories.category_2.title}`,
        "key": `${Category_2_Products.product_7.key}`,
        "title": `${Category_2_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_2_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [
            "Diameter: 5mm to 10mm",
            "Lenght: Standard / Bariatric",
            "Size: Medium-Large / Large / Extra-Large"
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_2.key}`,
        "parentTitle": `${Categories.category_2.title}`,
        "key": `${Category_2_Products.product_8.key}`,
        "title": `${Category_2_Products.product_8.title}`,
        "imageURL": `/assets/images/${Category_2_Products.product_8.key}.jpg`,
        "description": [
            "Table mount Retrector with accessories."
        ],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_2.key}`,
        "parentTitle": `${Categories.category_2.title}`,
        "key": `${Category_2_Products.product_9.key}`,
        "title": `${Category_2_Products.product_9.title}`,
        "imageURL": `/assets/images/${Category_2_Products.product_9.key}.jpg`,
        "description": [],
        "specification": [
            "Diameter: 3mm to 5mm",
            "Lenght: Paediatric / Standard / Bariatric",
            "Jaw Type: Straight / Left Curve / Right Curve / Tooth / Self Align",
            "Handle Type: Straight / Co-Axial / Ring"
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_3.key}`,
        "parentTitle": `${Categories.category_3.title}`,
        "key": `${Category_3_Products.product_1.key}`,
        "title": `${Category_3_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_3_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_3.key}`,
        "parentTitle": `${Categories.category_3.title}`,
        "key": `${Category_3_Products.product_2.key}`,
        "title": `${Category_3_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_3_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_3.key}`,
        "parentTitle": `${Categories.category_3.title}`,
        "key": `${Category_3_Products.product_3.key}`,
        "title": `${Category_3_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_3_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_3.key}`,
        "parentTitle": `${Categories.category_3.title}`,
        "key": `${Category_3_Products.product_4.key}`,
        "title": `${Category_3_Products.product_4.title}`,
        "imageURL": ``,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_3.key}`,
        "parentTitle": `${Categories.category_3.title}`,
        "key": `${Category_3_Products.product_5.key}`,
        "title": `${Category_3_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_3_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_3.key}`,
        "parentTitle": `${Categories.category_3.title}`,
        "key": `${Category_3_Products.product_6.key}`,
        "title": `${Category_3_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_3_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_3.key}`,
        "parentTitle": `${Categories.category_3.title}`,
        "key": `${Category_3_Products.product_7.key}`,
        "title": `${Category_3_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_3_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_1.key}`,
        "title": `${Category_4_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_2.key}`,
        "title": `${Category_4_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_3.key}`,
        "title": `${Category_4_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_4.key}`,
        "title": `${Category_4_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_5.key}`,
        "title": `${Category_4_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_6.key}`,
        "title": `${Category_4_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_7.key}`,
        "title": `${Category_4_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_8.key}`,
        "title": `${Category_4_Products.product_8.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_8.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_9.key}`,
        "title": `${Category_4_Products.product_9.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_9.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_10.key}`,
        "title": `${Category_4_Products.product_10.title}`,
        "imageURL": ``,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_4.key}`,
        "parentTitle": `${Categories.category_4.title}`,
        "key": `${Category_4_Products.product_11.key}`,
        "title": `${Category_4_Products.product_11.title}`,
        "imageURL": `/assets/images/${Category_4_Products.product_11.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_5.key}`,
        "parentTitle": `${Categories.category_5.title}`,
        "key": `${Category_5_Products.product_1.key}`,
        "title": `${Category_5_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_5_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_5.key}`,
        "parentTitle": `${Categories.category_5.title}`,
        "key": `${Category_5_Products.product_2.key}`,
        "title": `${Category_5_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_5_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_5.key}`,
        "parentTitle": `${Categories.category_5.title}`,
        "key": `${Category_5_Products.product_3.key}`,
        "title": `${Category_5_Products.product_3.title}`,
        "imageURL": ``,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_5.key}`,
        "parentTitle": `${Categories.category_5.title}`,
        "key": `${Category_5_Products.product_4.key}`,
        "title": `${Category_5_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_5_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_5.key}`,
        "parentTitle": `${Categories.category_5.title}`,
        "key": `${Category_5_Products.product_5.key}`,
        "title": `${Category_5_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_5_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_5.key}`,
        "parentTitle": `${Categories.category_5.title}`,
        "key": `${Category_5_Products.product_6.key}`,
        "title": `${Category_5_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_5_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_5.key}`,
        "parentTitle": `${Categories.category_5.title}`,
        "key": `${Category_5_Products.product_7.key}`,
        "title": `${Category_5_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_5_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_6.key}`,
        "parentTitle": `${Categories.category_6.title}`,
        "key": `${Category_6_Products.product_1.key}`,
        "title": `${Category_6_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_6_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_6.key}`,
        "parentTitle": `${Categories.category_6.title}`,
        "key": `${Category_6_Products.product_2.key}`,
        "title": `${Category_6_Products.product_2.title}`,
        "imageURL": ``,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_6.key}`,
        "parentTitle": `${Categories.category_6.title}`,
        "key": `${Category_6_Products.product_3.key}`,
        "title": `${Category_6_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_6_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_6.key}`,
        "parentTitle": `${Categories.category_6.title}`,
        "key": `${Category_6_Products.product_4.key}`,
        "title": `${Category_6_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_6_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_6.key}`,
        "parentTitle": `${Categories.category_6.title}`,
        "key": `${Category_6_Products.product_5.key}`,
        "title": `${Category_6_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_6_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_6.key}`,
        "parentTitle": `${Categories.category_6.title}`,
        "key": `${Category_6_Products.product_6.key}`,
        "title": `${Category_6_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_6_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_6.key}`,
        "parentTitle": `${Categories.category_6.title}`,
        "key": `${Category_6_Products.product_7.key}`,
        "title": `${Category_6_Products.product_7.title}`,
        "imageURL": ``,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_7.key}`,
        "parentTitle": `${Categories.category_7.title}`,
        "key": `${Category_7_Products.product_1.key}`,
        "title": `${Category_7_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_7_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [
            "Wound and Nerve Hooks",
            "Wound, Vein-Retractors",
            "Retractors, Double-Ended",
            "Retractors for Deep Surgery",
            "Lung Retractors, Scapula Retractors",
            "Retractors and Lung Spatulas",
            "Abdominal and Intestinal Spactulas"
        ],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_7.key}`,
        "parentTitle": `${Categories.category_7.title}`,
        "key": `${Category_7_Products.product_2.key}`,
        "title": `${Category_7_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_7_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_7.key}`,
        "parentTitle": `${Categories.category_7.title}`,
        "key": `${Category_7_Products.product_3.key}`,
        "title": `${Category_7_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_7_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_7.key}`,
        "parentTitle": `${Categories.category_7.title}`,
        "key": `${Category_7_Products.product_4.key}`,
        "title": `${Category_7_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_7_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_7.key}`,
        "parentTitle": `${Categories.category_7.title}`,
        "key": `${Category_7_Products.product_5.key}`,
        "title": `${Category_7_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_7_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_7.key}`,
        "parentTitle": `${Categories.category_7.title}`,
        "key": `${Category_7_Products.product_6.key}`,
        "title": `${Category_7_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_7_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_7.key}`,
        "parentTitle": `${Categories.category_7.title}`,
        "key": `${Category_7_Products.product_7.key}`,
        "title": `${Category_7_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_7_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_1.key}`,
        "title": `${Category_8_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_2.key}`,
        "title": `${Category_8_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_3.key}`,
        "title": `${Category_8_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_4.key}`,
        "title": `${Category_8_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_5.key}`,
        "title": `${Category_8_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_6.key}`,
        "title": `${Category_8_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_7.key}`,
        "title": `${Category_8_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_8.key}`,
        "title": `${Category_8_Products.product_8.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_8.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_9.key}`,
        "title": `${Category_8_Products.product_9.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_9.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_10.key}`,
        "title": `${Category_8_Products.product_10.title}`,
        "imageURL": `/assets/images/${Category_8_Products.product_10.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": false,
        "parentkey": `${Categories.category_8.key}`,
        "parentTitle": `${Categories.category_8.title}`,
        "key": `${Category_8_Products.product_11.key}`,
        "title": `${Category_8_Products.product_11.title}`,
        "imageURL": "",
        "description": [],
        "technicalSpecifications": [
            "Large Fragment Instrument Set",
            "Small Fragment Instrument Set",
            "Mini Fragment Instrument Set",
            "TBW Instrument Set",
            "K-wire and pin Instrument Set",
            "Ostcotomy Instrument Set",
            "Bone Punch Instrument Set",
            "Bending Pliers Set",
            "Broken Screw Instrument Set",
            "Nail Removal Instrument Set",
            "MIPPO Instrument Set",
            "Shoulder Retractor Instrument Set",
            "Cement Removal Instrument Set",
            "Cervical Retractor Instrument Set",
            "Lumbar Retractor Instrument Set",
            "Thoracotomy Instrument Set",
            "Laproscopic Insturment Set",
            "Thompson Retractor Instrument Set",
            "Cronial Instrument Set",
            "Maxillofacial Instrument Set",
            "Reamer with Cannulation/Hand Reamer Instrument Set",
            "Micro Vascular Instrument Set"
        ],
        "specification": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_9.key}`,
        "parentTitle": `${Categories.category_9.title}`,
        "key": `${Category_9_Products.product_1.key}`,
        "title": `${Category_9_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_9_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_9.key}`,
        "parentTitle": `${Categories.category_9.title}`,
        "key": `${Category_9_Products.product_2.key}`,
        "title": `${Category_9_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_9_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_9.key}`,
        "parentTitle": `${Categories.category_9.title}`,
        "key": `${Category_9_Products.product_3.key}`,
        "title": `${Category_9_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_9_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_9.key}`,
        "parentTitle": `${Categories.category_9.title}`,
        "key": `${Category_9_Products.product_4.key}`,
        "title": `${Category_9_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_9_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_9.key}`,
        "parentTitle": `${Categories.category_9.title}`,
        "key": `${Category_9_Products.product_5.key}`,
        "title": `${Category_9_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_9_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_9.key}`,
        "parentTitle": `${Categories.category_9.title}`,
        "key": `${Category_9_Products.product_6.key}`,
        "title": `${Category_9_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_9_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_9.key}`,
        "parentTitle": `${Categories.category_9.title}`,
        "key": `${Category_9_Products.product_7.key}`,
        "title": `${Category_9_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_9_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_9.key}`,
        "parentTitle": `${Categories.category_9.title}`,
        "key": `${Category_9_Products.product_8.key}`,
        "title": `${Category_9_Products.product_8.title}`,
        "imageURL": `/assets/images/${Category_9_Products.product_8.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_1.key}`,
        "title": `${Category_10_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_2.key}`,
        "title": `${Category_10_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_3.key}`,
        "title": `${Category_10_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_4.key}`,
        "title": `${Category_10_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_5.key}`,
        "title": `${Category_10_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_6.key}`,
        "title": `${Category_10_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_7.key}`,
        "title": `${Category_10_Products.product_7.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_7.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_8.key}`,
        "title": `${Category_10_Products.product_8.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_8.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_10.key}`,
        "parentTitle": `${Categories.category_10.title}`,
        "key": `${Category_10_Products.product_9.key}`,
        "title": `${Category_10_Products.product_9.title}`,
        "imageURL": `/assets/images/${Category_10_Products.product_9.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_11.key}`,
        "parentTitle": `${Categories.category_11.title}`,
        "key": `${Category_11_Products.product_1.key}`,
        "title": `${Category_11_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_11_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_11.key}`,
        "parentTitle": `${Categories.category_11.title}`,
        "key": `${Category_11_Products.product_2.key}`,
        "title": `${Category_11_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_11_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_11.key}`,
        "parentTitle": `${Categories.category_11.title}`,
        "key": `${Category_11_Products.product_3.key}`,
        "title": `${Category_11_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_11_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_11.key}`,
        "parentTitle": `${Categories.category_11.title}`,
        "key": `${Category_11_Products.product_4.key}`,
        "title": `${Category_11_Products.product_4.title}`,
        "imageURL": `/assets/images/${Category_11_Products.product_4.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_11.key}`,
        "parentTitle": `${Categories.category_11.title}`,
        "key": `${Category_11_Products.product_5.key}`,
        "title": `${Category_11_Products.product_5.title}`,
        "imageURL": `/assets/images/${Category_11_Products.product_5.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_11.key}`,
        "parentTitle": `${Categories.category_11.title}`,
        "key": `${Category_11_Products.product_6.key}`,
        "title": `${Category_11_Products.product_6.title}`,
        "imageURL": `/assets/images/${Category_11_Products.product_6.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_12.key}`,
        "parentTitle": `${Categories.category_12.title}`,
        "key": `${Category_12_Products.product_1.key}`,
        "title": `${Category_12_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_12_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_12.key}`,
        "parentTitle": `${Categories.category_12.title}`,
        "key": `${Category_12_Products.product_2.key}`,
        "title": `${Category_12_Products.product_2.title}`,
        "imageURL": `/assets/images/${Category_12_Products.product_2.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_12.key}`,
        "parentTitle": `${Categories.category_12.title}`,
        "key": `${Category_12_Products.product_3.key}`,
        "title": `${Category_12_Products.product_3.title}`,
        "imageURL": `/assets/images/${Category_12_Products.product_3.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_12.key}`,
        "parentTitle": `${Categories.category_12.title}`,
        "key": `${Category_12_Products.product_4.key}`,
        "title": `${Category_12_Products.product_4.title}`,
        "imageURL": ``,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_13.key}`,
        "parentTitle": `${Categories.category_13.title}`,
        "key": `${Category_13_Products.product_1.key}`,
        "title": `${Category_13_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_13_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_14.key}`,
        "parentTitle": `${Categories.category_14.title}`,
        "key": `${Category_14_Products.product_1.key}`,
        "title": `${Category_14_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_14_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    },
    {
        "showTitle": true,
        "parentkey": `${Categories.category_15.key}`,
        "parentTitle": `${Categories.category_15.title}`,
        "key": `${Category_15_Products.product_1.key}`,
        "title": `${Category_15_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_15_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    }
    , {
        "showTitle": true,
        "parentkey": `${Categories.category_16.key}`,
        "parentTitle": `${Categories.category_16.title}`,
        "key": `${Category_16_Products.product_1.key}`,
        "title": `${Category_16_Products.product_1.title}`,
        "imageURL": `/assets/images/${Category_16_Products.product_1.key}.jpg`,
        "description": [],
        "specification": [],
        "technicalSpecifications": []
    }
]